import { IValueViewModel } from '../../models';
import { ITileViewModel } from './ITileViewModel';

export class TileViewModel implements ITileViewModel {
    actualValue?: number;
    alarmClass: string;
    decimals: number;
    guid: string;
    selection: string;
    style: { [cssClass: string]: string; };
    top: string;
    value: string;
    viewModel: IValueViewModel;

    constructor(
        value: string,
        guid: string,
        decimals: number,
        backgroundColor: string,
        fontColor: string,
        fontSize: number,
        relativeWidth: number,
        alarmClass: string,
        viewModel: IValueViewModel,
        selection: string
    ) {

        this.selection = selection;
        this.decimals = decimals;
        this.value = value;
        this.guid = guid;
        this.alarmClass = alarmClass;
        this.viewModel = viewModel;

        if (alarmClass !== '') {
            this.style = {
                'font-size': `${fontSize}px`,
                'flex-basis': relativeWidth + '%'
            };
        } else {
            this.style = {
                'background-color': backgroundColor,
                'color': fontColor,
                'font-size': `${fontSize}px`,
                'flex-basis': relativeWidth + '%',
                'text-decoration': 'none'
            };
        }
        // Not needed anymore?
        this.top = `${-fontSize / 12}px`;
    }
}
